export default "__VITE_ASSET__96c47a9b__"